<style scoped lang="scss">
    h4 {
        margin: 0;
    }
    .select-wrapper {
        label {
            padding-left: 10px;
        }
        input {
            margin-left: 20px;
        }
    }
    .info-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        label {
            display: inline-block;
            width: 330px;
        }
        .text-input {
            width: 265px;
        }
    }
    table {
        tr {
            border-bottom: 1px dashed #efefef;
        }
    }
</style>

<template>
    <div class="uk-width-1-1 uk-grid">
        <header-row></header-row>
        <div class="uk-width-1-1 uk-margin-top">
            <p>
                If you declare that no one in your household receives a source of income you must provide a
                statement on how you meet your MONTHLY living expenses:
            </p>

            <table class="uk-table uk-hidden-small">
                <thead>
                <tr>
                    <th>Monthly Expense</th>
                    <th>Monthly Amount</th>
                    <th>How does it get paid?</th>
                    <th>Who pays it?</th>
                    <th>Contact Phone</th>
                    <th>Contact Email</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="income in incomes">
                    <td>{{ income.label }}</td>
                    <td>
                        {{ income.amount }}
                    </td>
                    <td>
                        <span class="uk-text-capitalize">{{ income.method }}</span>
                    </td>
                    <td>
                        {{ income.payer }}
                    </td>
                    <td>
                        {{ income.payer_phone }}
                    </td>
                    <td>
                        {{ income.payer_email }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="uk-width-1-1 uk-margin-large-top">
            <p>Under penalty of perjury, I certify that the information presented in this certification is true and accurate to the best of my knowledge.  I further understand that providing false representations constitutes an act of fraud. False, misleading, or incomplete information may result in the repayment of any funds received through the <b>{{ program['program_abbreviation'] }}</b> Program and other remedies available under applicable law.  I also give the <b>{{ program['agency_short_name'] }}</b> and its partners permission to obtain a copy of any tax returns from the Internal Revenue Service and to verify income and other information provided herein from other State agencies.</p>
        </div>

        <div class="uk-width-1-1">
            <signatures label="Printed Name of Household Member"></signatures>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from "vuex";
    import ApplicantData from "../Partials/ApplicantData";
    import ApplicantIncome from "../Partials/ApplicantIncome";
    import HeaderRow from "../Partials/HeaderRow";
    import ReviewResults from "../Partials/ReviewResults";
    import AttachedDocuments from "../Partials/AttachedDocuments";
    import BlankPage from "../Partials/BlankPage";
    import PrintableSignature from "../Partials/PrintableSignature";
    import Signatures from "../Partials/Signatures";

    export default {
        name: "NoIncomeEntireHHAttestation",
        props: {
            member: {
                type: Object,
                default: {},
            },
            incomes: {
                type: Array,
                default: [],  
            }
        },
        components: {
            Signatures,
            PrintableSignature,
            BlankPage, AttachedDocuments, ReviewResults, HeaderRow, ApplicantIncome, ApplicantData},
        data() {
            return {
            }
        },
        computed: {
            ...mapState('Application', {
                application: 'application',
            }),
            
            ...mapGetters('Application', [ 'program', 'programSettings' ]),

            fullName() {
                return this.member.first_name + ' ' + this.member.last_name
            }
        },
    }
</script>
